import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'
import { slugToCode } from '@/lib/ic3'

/**
 * Layout-only parent for /states/$slug (state overview, states.$slug.index)
 * and /states/$slug/scams/$scamSlug (per-state scam pages). It must render
 * an Outlet, not the state page itself: rendering StatePage here made every
 * /states/<slug>/scams/<scamSlug> URL show the state overview instead - the
 * 255 per-state scam pages the registry was built for were unreachable.
 */
export const Route = createFileRoute('/states/$slug')({
  beforeLoad: ({ params }) => {
    const code = slugToCode(params.slug)
    if (!code) throw notFound()
  },
  component: () => <Outlet />,
})
